var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M233.625 755.291C178.135 766.78 64.371 790.8 58.64 785.711c-15.982-10.874-32.954-4.258-22.85 10.4 16.24 27.58 41.082 52.952 53.053 82.844 2.289 4.334 4.579 5.01 6.867 4.976 34.894.598 59.617-7.137 92.96-10 5.246-.506 12.18 5.197 16.077 3.494 3.453-1.88 4.89-8.567 5.8-12.759 6.858-25.415 28.052-47.677 39.896-72.713 1.505-2.995 9.845-3.55 9.782-6.44-1.22-10.817-17.304-30.706-26.6-30.222zm-23.14 33.579c12.463-.305-.398 25.045-5.5 26.11-5.685.836-6.591-7.302-13.558-7.445-5.234.548-4.043 3.93-9.439 5.54-32.92 6.465-57.052 8.76-91.401 12.136-4.333.11-15.065-17.221-9.014-18.63 40.94-9.937 109.784-17.444 128.913-17.711zm-16.389 50.027c4.014 6.867-2.844 13.8-7.809 14.563-30.193 4.515-78.253 12.148-82.006 8.231-2.67-2.844-8.083-10.979-7.222-16.538 11.136-3.715 92.3-14.424 97.038-6.256z",
    style: {
      fill: "#142896",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    transform: "matrix(.9007 0 0 .97529 22.48 -631.283)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.101 656.13c-18.37-7.4-20.372 5.833-17.903 14.339 6.214 20.201 14.429 28.632 24.539 42.678 1.805 2.418 3.809 7.059 3.505 9.27l-2.804 207.597c.025 6.499-1.223 27.056-5.337 23.814-16.257-12.357-21.17-19.293-47.244-51.546-11.141-14.929-19.889-6.944-6.366 12.591 42.46 54.624 46.08 59.834 46.707 115.107 1.624 29.179 31.758 24.649 34.572 6.138 3.43-19.971-1.647-51.783-1.85-73.761-.774-84.028-.86-158.338 12.845-239.534 2.594-12.667 22.99-23.066 33.975-26.71 4.866-1.62 10.287-13.975.9-14.453-25.18-2.649-52.283-15.551-75.539-25.53z",
    style: {
      fill: "#142896",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    transform: "matrix(.9007 0 0 .97529 22.48 -631.283)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.059 749.955c-28.498-1.307-7.408 15.787-1.003 15.355 35.47-3.222 93.934-11.664 130.102-19.89 2.503-.078-.19-17.19-17.338-18.919-5.213-.255-4.317 2.601-10.48 4.835-27.632 6.003-76.155 20.22-101.281 18.62zm11.021 110.52c-20.041 38.808-38.468 52.625-99.097 78.81-23.46 9.394-21.788 23.654 6.644 13.897 77.17-29.987 93.352-48.707 105.936-85.053Zm47.824.762c24.812 28.938 58.744 106.952 77.56 95.367 14.853-9.54 33.95-10.668 42.066-8.482 10.623 2.799 11.134 7.754 17.08 10.97 15.635 6.588 12.364-2.021 6.937-9.595-14.043-21.6-80.571-34.668-122.31-92.57z",
    style: {
      fill: "#142896",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    transform: "matrix(.9007 0 0 .97529 22.48 -631.283)"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTon);
export default __webpack_public_path__ + "static/media/Ton.f129fd066e4586cd4c6b8304a66b1980.svg";
export { ForwardRef as ReactComponent };